<template>
  <div>
    <v-row justify="space-around">
      <v-row>
        <v-col cols="3" class="pl-8">
          <v-avatar size="80px">
            <v-tooltip
              transition="slide-y-transition"
              right
              content-class="avatar-tooltip"
            >
              <template v-slot:activator="{ on }">
                <img
                  id="js-avatar"
                  :src="avatar"
                  alt="personal avatar missing?"
                  @click="showUpload = true"
                  v-on="on"
                />
              </template>
              <span>Click to upload a profile photo</span>
            </v-tooltip>
          </v-avatar>
        </v-col>
        <v-col>
          <h1>
            <span id="js-first">{{ firstName }}</span>
            &nbsp;
            <span id="js-last">{{ lastName }}</span>
          </h1>
        </v-col>
      </v-row>

      <vue-image-crop-upload
        field="img"
        @crop-success="submitFiles"
        v-model="showUpload"
        :width="200"
        :height="200"
        lang-type="en"
        img-format="png"
        no-square
      />
    </v-row>
    <user-details v-if="userId" :userId="userId"></user-details>
  </div>
</template>

<script>
import { UsersAPI } from "@/lib/api"
import titleMixin from "@/mixins/titleMixin"
import userMixin from "@/mixins/userMixin"
import UserDetails from "@/containers/users/UserDetails"
import VueImageCropUpload from "vue-image-crop-upload"
import base64js from "base64-js"

export default {
  mixins: [titleMixin, userMixin],
  components: { VueImageCropUpload, UserDetails },
  data: function() {
    return {
      title: "Your User Profile",
      showUpload: false
    }
  },
  computed: {
    firstName() {
      let user = this.$store.getters["users/getMe"]
      return user ? user.first_name : ""
    },
    lastName() {
      let user = this.$store.getters["users/getMe"]
      return user ? user.last_name : ""
    },
    avatar() {
      let user = this.$store.getters["users/getMe"]
      return user ? user.avatar : ""
    },
    userId() {
      let user = this.$store.getters["users/getMe"]
      return user ? user.id : null
    }
  },
  methods: {
    submitFiles(base64Image, field) {
      // convert the image from base64 to binary format
      let byteImage = base64js.toByteArray(base64Image.split(",")[1])
      let file = new File([byteImage], "avatar.png")

      this.$store.dispatch("users/updateAvatar", { userId: this.userId, file })
    }
  },
  created() {
    this.$store.dispatch("users/loadMe")
  }
}
</script>

<style lang="scss" scoped>
@import "../../scss/variables";

img {
  cursor: pointer;
}
.avatar-tooltip {
  background-color: $beige;
  color: $dark-blue;
  font-size: 1.2em;
}
</style>
